import { useEffect, useState } from "react";
import { Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import collaborationApi from "../../../../api/collaborationApi";
import ChatModal from "./ChatModal";

const Chat = ({ collabId, collaborationName }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const initialTab = queryParams.get("chatMode") || "groupChat";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Fetch contributors
  useEffect(() => {
    if (collabId) {
      collaborationApi
        .getContributorsDetails(collabId)
        .then((response) => {
          const contributorsData = response.data.map((item) => ({
            id: item[0],
            name: item[1],
            email: item[2],
            role: item[3],
            createdBy: item[4],
          }));
          setContributors(contributorsData);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching contributors:", err);
          setError("Failed to load contributors.");
          setLoading(false);
        });
    }
  }, [collabId]);

  const handleTabSelect = (key) => {
    setActiveTab(key);
    const params = new URLSearchParams(location.search);
    params.set("chatMode", key);
    params.set("tab", "chat");
    navigate(
      `${location.pathname}?${params.toString()}`,
      { replace: true, state: location.state },
    );
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    const chatMode = params.get("chatMode");

    if (tab === "chat" && !chatMode) {
      params.set("chatMode", "groupChat");

      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
        state: location.state,
      });
    }
  }, [location.search, navigate]);

  return (
    <>
      <br />
      <h4>
        <strong>Chat for {collaborationName}</strong>           
      </h4>

      <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
        <Tabs.Tab eventKey="groupChat" title="Group Chat">
          <ChatModal
            collabId={collabId}
            collaborationName={collaborationName}
            contributors={contributors}
            chatType="collaboration"
            isGroupChat={true}
          />
        </Tabs.Tab>

        <Tabs.Tab eventKey="privateChat" title="1X1 Chat">
          <ChatModal
            collabId={collabId}
            collaborationName={collaborationName}
            contributors={contributors}
            chatType="collaboration"
            isGroupChat={false}
          />
        </Tabs.Tab>
      </Tabs>
    </>
  );
};

export default Chat;
